// extracted by mini-css-extract-plugin
export default {"icon":"SkillIcon_icon__0wrUy","icon-wrapper":"SkillIcon_icon-wrapper__1FwJR"};